/**
 * The separator used to split the search term into multiple search terms.
 */
export const SEARCH_TERM_SEPARATOR = '[&&]';

/**
 * The maximum number of search terms that can be used.
 */
export const MAX_SEARCH_TERMS = 15;
